export default {
    state: {
        findJobsPage: 2,
        totalPostingCount: 0,
    },
    getters: {
        findJobsPage: state => payload => state.findJobsPage,
        totalPostingCount: state => payload => state.totalPostingCount,
    },
    mutations: {
        setFindJobsPage(state, page) {
            state.findJobsPage = page;
        },
        setTotalPostingCount(state, count) {
            state.totalPostingCount = count;
        },
    },
};
